import { motion } from "framer-motion";

export default function Intro() {
  return (
    <section data-testid="intro-section" className="relative py-32 lg:py-48 px-6 lg:px-24">
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-3">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="font-mono text-[10px] tracking-[0.35em] text-goldw uppercase"
          >
            Chapter 01 — Introduction
          </motion.p>
          <motion.div
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="w-px h-32 bg-goldw/40 mt-8 origin-top hidden lg:block"
          />
        </div>
        <div className="lg:col-span-9">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif font-light text-3xl sm:text-5xl lg:text-6xl leading-[1.15] text-ivory max-w-5xl"
            data-testid="intro-headline"
          >
            AMAA Design &amp; Build is a Dallas–Fort Worth construction partner for
            homeowners who believe a house should be{" "}
            <span className="italic text-goldw">composed</span>, not assembled — where
            planning, craftsmanship and light are treated as one discipline.
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.25 }}
            className="mt-14 grid sm:grid-cols-2 gap-10 max-w-3xl"
          >
            <p className="text-sm sm:text-base text-zinc2 leading-relaxed">
              From our studio in Farmers Branch, we take on a deliberate number of custom
              homes, remodels and full renovations across the Metroplex — enough to stay
              obsessed with every one of them.
            </p>
            <p className="text-sm sm:text-base text-zinc2 leading-relaxed">
              Kitchens, bathrooms, additions, structural transformations and ground-up
              residences — each project runs on clear communication, premium materials and
              details that hold up to a closer look.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
